export default "__VITE_ASSET__S4$gXQry__"